import React from "react"
import {useTranslation} from "react-i18next"
import {IonAccordion, IonItem, IonLabel, IonNote} from "@ionic/react"

import LockingSystem from "@customTypes/LockingSystem";

interface componentProps {
    lockingSystem: LockingSystem | undefined
}

export const AccordionLockingSystem: React.FC<componentProps> = ({ lockingSystem }) => {

    const { t } = useTranslation()

    return (
        <IonAccordion toggleIconSlot="start" value="lockingSystem">
            <IonItem className="bc-accordion" slot="header">
                <IonLabel>{t('common.locking_system')}</IonLabel>
            </IonItem>
            <IonItem slot="content">
                <IonLabel>{t('keys.form.locking_system')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{lockingSystem ? lockingSystem.name : '?'}</IonNote>
            </IonItem>
        </IonAccordion>
    )
}

export default AccordionLockingSystem